import { Component, Input } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController, ModalController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { CuentasPorCobrarProvider } from '../../providers/cuentas-por-cobrar/cuentas-por-cobrar'
import { CajaProvider } from '../../providers/caja/caja'
import { Storage } from '@ionic/storage'
import { interval } from '../../../node_modules/rxjs/observable/interval';
import * as XLSX from 'xlsx';
import { File } from '@ionic-native/file';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { UtilsProvider } from '../../providers/utils/utils'
import { NUBE_AWS } from '../../config/url.servicio';
import { AuthService } from '../../providers/auth-service';
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales';
import { Base64 } from 'js-base64';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { valueDisplay } from '../../models/valueDisplay.model';
import { DianProvider } from '../../providers/dian/dian';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { State } from '../../store/app.reducer'
import { Store } from '@ngrx/store';
import * as fromClienteSelect from '../cliente-select/state/cliente-select/cliente-select-accions'
import { ClienteSelectPage } from '../cliente-select/cliente-select';
import { saveAs } from 'file-saver';
import { WhatsappPage } from '../whatsapp/whatsapp';

type AOA = any[][];
@IonicPage()
@Component({
  selector: 'page-cuentas-por-cobrar',
  templateUrl: 'cuentas-por-cobrar.html',
  providers: [ File,InAppBrowser, AuthService, ParametrosGeneralesRedux, DianProvider ]
})

export class CuentasPorCobrarPage {

  @Input() arrayWhereLocal: any = []
  public clientesId:any
  recibo:string = "";
  pagoTotal:boolean=false
  datosCredito = []
  clienteId = []
  valoresTotales = []
  valorPagado:number = 0
  valorPendiente:number = 0
  data: any[][]
  companiasId;
  bluetooth:boolean = false
  fechaPagoReal:Date
  detalle:string = ''
  comprobantePago:string = ''
  listaClientes = [];
  valoresCliente: string = 'Buscar Cliente';
  isLoading: boolean = false;
  public isButtonDisabledCliente: boolean = false;
  public isButtonDisabledPago: boolean = false;
  interesCreditos:any[] = []
  planDePagos:any[]=[]
  CheckImprimir:boolean = false
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public buscarCuentasPorCobrarProvider:CuentasPorCobrarProvider,
              public servicio:CajaProvider,
              private storage: Storage,
              public alertControllers: AlertController,
              public file: File,private iab: InAppBrowser,
              public utils: UtilsProvider,
              public auth: AuthService,
              public utilsParametrosGeneralesRedux: ParametrosGeneralesRedux,
              public dian: DianProvider,
              private store:Store<State>,
              public modalControllers: ModalController
              ) {
                const savedState = localStorage.getItem('ImprimirCuentasPorCobrar');
                this.CheckImprimir = savedState === 'true';
                this.buscarDatosIniciales();

  }

 async buscarDatosIniciales() {
    let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
    if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
      this.companiasId = buscarParametrosGeneralesStore.parametrosGenerales[0][0].companiasId
      this.bluetooth = buscarParametrosGeneralesStore.parametrosGenerales[0][0].bluetooth
    }
    this.buscarIntereses(this.companiasId)
  }

  buscarIntereses(companiasId:any){
    this.servicio.buscarIntereses(companiasId).subscribe(async (data: any)=>{
      if(NUBE_AWS) {
        data = JSON.parse(data['_body']).data[0]
        this.interesCreditos = data
      }
    },(error)=> console.log(error))
  }

  read(bstr: string) {
    const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});
    const wsname: string = wb.SheetNames[0];
    const ws: XLSX.WorkSheet = wb.Sheets[wsname];
    this.data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
  };



cambiarPagoTotal(){
  this.pagoTotal = !this.pagoTotal
}

cerrarSession() {
  this.auth.logout()
  this.navCtrl.setRoot('LoginPage');
}


buscarCuentaPorCobrarValorTotal(val:any,clienteId:any){
  this.servicio.buscarCuentaPorCobrarValorTotal(val,clienteId)
  .subscribe(
    rest => {
      if(NUBE_AWS){
        let res = JSON.parse(rest['_body']).data[0] === undefined ? [] : JSON.parse(rest['_body']).data[0]
        this.pagoTotal = res
        this.valorPagado = res[0].valorPagado
        this.valorPendiente = res[0].valorPendiente
      } else {
        let res = JSON.parse(rest['_body'])
        this.pagoTotal = res
        this.valorPagado = res[0].valorPagado
        this.valorPendiente = res[0].valorPendiente
      }
    },
    error => {
      console.log(error)
    })
}

buscarCuentaPorCobrar(numeroFactura:any){

  this.storage.get('companiasId').then((val) => {

      let jsonFiltro = []

      let clienteId

      if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
       clienteId = this.clienteId[0]['value']
      }else{
        return false
      }

    jsonFiltro.push(
      {companiasId:val,clientesId:clienteId,numeroFactura:numeroFactura}
    )
    this.buscarCuentaPorCobrarValorTotal(val,clienteId)
    this.servicio.buscarCuentaPorCobrar(jsonFiltro)
    .subscribe(
      rest => {
        if(NUBE_AWS){
          let res = JSON.parse(rest['_body']).data[0] === undefined ? [] : JSON.parse(rest['_body']).data[0]
          this.datosCredito = res
        } else {
          let res = JSON.parse(rest['_body'])
          this.datosCredito = res[0]
        }

        if(this.datosCredito.length==0){
          this.utils.mensajeMuestro('No existen cuentas por cobrar para este cliente','Verifique','warning')
          this.pagoTotal = false
        }

      },
      error => {
        console.log(error)
      })
   })


}
limpiar(){
  this.clienteId = []
  this.valoresTotales = []
  this.datosCredito = []
  this.valorPagado = 0
  this.valorPendiente = 0
  this.buscarCuentaPorCobrar('')
  this.limpiarCampos()
  this.valoresCliente = 'Buscar Cliente : '
  this.planDePagos = []
}
mostrarMensajeAdvertencia(mensaje,titulo) {
  let alert = this.alertControllers.create({
    title: titulo,
    subTitle: mensaje,
    buttons: ['Cerrar']
  });
  alert.present();
}

printD(codigo:any) {
  this.storage.get('companiasId').then((companiasId)=>{
    this.servicio.imprimirComandaBlue(codigo,companiasId)

   .subscribe((data)=>{



   let items = JSON.parse(data['_body']).data
   this.imprimirArchivoBlue(items[0])
   })
})
}

imprimirArchivoBlue(datos) {
  let datanew = datos
  let recibo = ''

  for (let index:any = 0; index < datanew.length; index++) {
    recibo +=  '   ' + datanew[index]['reciboCaja'] + '\n'
  }

  let encodedString = Base64.encode(recibo);
  window.open(`sartprintbluetooth://print/${encodedString}`, '_self');

}

imprimirCuentaPorCobrar(codigo:any){
    this.storage.get('companiasId').then((val) => {

    if(1===1) {

    }

    this.servicio.buscarFacturaCuentaPorCobrar(codigo,val)
    .subscribe((data)=>{
      let res = NUBE_AWS ? JSON.parse(data['_body']).data : data
      let response = NUBE_AWS ? res[0] : res.json()
      if(this.CheckImprimir){
      this.reemprimirRecibo(response)
      }
    },
     error=>{
       console.log(error)
     })
    })
}

reemprimirRecibo(mensaje) {
  let recibo = ''
  mensaje = mensaje == undefined ? [] : mensaje
for (let index:any = 0; index < mensaje.length; index++) {
  recibo += mensaje[index]['reciboCaja'] + '\n'
}

  this.servicio.imprimirRecibo(recibo).subscribe(
      res => {

      },
      err => {

              let alert = this.alertControllers.create({
                  title: '',
                  subTitle: recibo,
                  buttons: ['Cerrar']
              });
              alert.present();

          })
}

mensaje(){
  this.utils.mensajeMuestro('Se puede pagar el total de la deuda al seleccionar el boton "Pagar valor total"','Mensaje general','warning')
}

pagarCreditoTotal(){
  this.isButtonDisabledPago = true

  this.getMultiple(['usuariosId','companiasId'])
  .then( res => {
    let usuariosId = res['usuariosId']
    let companiasId = res['companiasId']
    let clienteId

    if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
     clienteId = this.clienteId[0]['value']
    }else{
      this.utils.mensajeMuestro('Debe de seleccionar un cliente','Advertencia','warning')
      return false
    }

    for(let i=0;i<this.datosCredito.length;i++){
      let elPago = []
      let totalPagado = this.datosCredito[i].valorPendiente
      let cuentasPorCobrarId = this.datosCredito[i].cuentasPorCobrarId

      elPago.push({usuariosId:usuariosId,
                   companiasId:companiasId,
                   clientesId: clienteId,
                   totalPagado:totalPagado,
                   cuentasPorCobrarId:cuentasPorCobrarId,
                   fechaPagoReal:this.fechaPagoReal,
                   detalle:this.detalle,
                   comprobantePago:this.comprobantePago


      })

      this.servicio.almacenarPagoCuentaPorCobrar(elPago)
        .subscribe((data)=>{
          let res
          if(NUBE_AWS){
            res = JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data[0]
          } else {
            res = JSON.parse(data['_body'])
          }
          res = NUBE_AWS ? res : res[0]
          if(this.CheckImprimir){
            if(this.bluetooth) {
              this.imprimirArchivoBlue(res)
            } else {
              this.reemprimirRecibo(res)
            }
         }
          this.limpiar()
        },(error)=>{
          this.isButtonDisabledPago = false
          console.log(error)
        })
    }

  })

}

validarPagoDeCredito(item:any,valorPendienteInd:any){
  this.isButtonDisabledPago = true
  this.getMultiple(['usuariosId','companiasId'])
  .then( res => {

    let usuariosId =res['usuariosId']
    let companiasId =res['companiasId']

     let comprobantePago = this.comprobantePago == '' || this.comprobantePago == undefined ? '0' : this.comprobantePago
     if(this.interesCreditos.length>0) {
      this.pagarCredito(item,valorPendienteInd)
     } else {
      this.servicio.validarAlmacenarPagoCuentaPorCobrarPorCompania(comprobantePago,companiasId)
        .subscribe((data)=>{
          let res = NUBE_AWS ? JSON.parse(data['_body']).data : JSON.parse(data['_body'])

          if(res[0][0].existe === 0) {
            this.pagarCredito(item,valorPendienteInd)
          } else {
            let mensaje = ''
            mensaje+= 'El comprobante de pago ya existe en el sistema valide estos valores: \n'
            mensaje+= ` codigoUsuario: ${res[1][0].codigoUsuario} \n `
            mensaje+= ` detalle: ${res[1][0].detalle} \n `
            mensaje+= ` fecha: ${res[1][0].fecha} \n `
            mensaje+= ` identificacion: ${res[1][0].identificacion} \n `
            mensaje+= ` nombreCompleto: ${res[1][0].nombreCompleto} \n `
            mensaje+= ` nombreEntidad: ${res[1][0].nombreEntidad} \n `
            mensaje+= ` nombreUsuario: ${res[1][0].nombreUsuario} \n `
            mensaje+= ` numeroFactura: ${res[1][0].numeroFactura} \n `
            mensaje+= ` reciboPago: ${res[1][0].reciboPago} \n `
            mensaje+= ` valorFactura: ${res[1][0].valorFactura} \n `
            mensaje+= ` valorPagado: ${res[1][0].valorPagado} \n `
            mensaje+= ` valorTransaccion: ${res[1][0].valorTransaccion} \n `
            const blob = new Blob([mensaje], { type: 'text/plain;charset=utf-8' });
            saveAs(blob, `Factura: ${res[1][0].numeroFactura} - ${comprobantePago}.txt`);
            this.utils.mensajeMuestro(mensaje,'Advertencia','warning')
            this.isButtonDisabledPago = false
          }

        },(error)=>{
          this.isButtonDisabledPago = false
          console.log(error)
        })
     }

  })
}

pagarCredito(item:any,valorPendienteInd:any, manejaInteres:any = 0){

  this.getMultiple(['usuariosId','companiasId'])
  .then( res => {
    let usuariosId =res['usuariosId']
    let companiasId =res['companiasId']
    let clienteId

    if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
     clienteId = this.clienteId[0]['value']
    }else{
      this.utils.mensajeMuestro('Debe de seleccionar un cliente','Advertencia','warning')
      return false
    }

      let elPago = []

      let cuentasPorCobrarId = item.cuentasPorCobrarId
      var valorPendienteIndividual = valorPendienteInd['_value']
      var numerovalorPendienteIndividual = Number(valorPendienteIndividual)
      let totalPagado = 0
      if(numerovalorPendienteIndividual>0 && item.valorPendiente > numerovalorPendienteIndividual){
        totalPagado = numerovalorPendienteIndividual
      }else{
        totalPagado = item.valorPendiente
      }
      if(manejaInteres>0) {
        totalPagado = item.montoDeLaCuota < numerovalorPendienteIndividual ? numerovalorPendienteIndividual : item.montoDeLaCuota
      }
      elPago.push({usuariosId:usuariosId,
        companiasId:companiasId,
        clientesId:clienteId,
        totalPagado:totalPagado,
        cuentasPorCobrarId:cuentasPorCobrarId,
        fechaPagoReal:this.fechaPagoReal,
        detalle:this.detalle,
        comprobantePago:this.comprobantePago
      })
      let comprobantePago = this.comprobantePago
      let fechaPagoReal = this.fechaPagoReal
      this.servicio.almacenarPagoCuentaPorCobrar(elPago)
        .subscribe((data)=>{
          let res = NUBE_AWS ? JSON.parse(data['_body']).data : JSON.parse(data['_body'])
          this.utils.mensajeConfirmacionDos('WS','¿Desea enviar el comprobante por WhatSapp?','question','Si','No')
          .then((ws: boolean) => {
           if (ws) {
            let numero = ''
            if(res[0] != undefined && res[0][11] != undefined) {
              numero = this.devolverTel(res[0][11])
            }

            var numerovalorPendienteIndividual = Number(valorPendienteIndividual)
            item.valorPagado = item.valorPagado + numerovalorPendienteIndividual
            item.valorPendiente = item.valorPendiente - numerovalorPendienteIndividual
            item.comprobantePago = comprobantePago
            item.fechaPagoReal = fechaPagoReal
            let dataImprimir = JSON.stringify(res[0])
            let modal = this.modalControllers.create(WhatsappPage, { dataImprimir: dataImprimir, numeroTelefono: numero, espacios: false }
              )
            modal.present();

            modal.onDidDismiss(data => {
              if (data) {
              }
            })
           }
           else {
            if(this.CheckImprimir){
              if(this.bluetooth) {
                this.imprimirArchivoBlue(res[0])
              } else {
              this.reemprimirRecibo(res[0])
              }
            }

           }
         })
         this.planDePagos = []
          this.limpiar()
          this.isButtonDisabledPago = false
        },(error)=>{
          this.isButtonDisabledPago = false
          console.log(error)
        })
  })
}

devolverTel(tel: any) {
  let cadenaOriginal = tel.reciboCaja;
  let valorEliminar = "Tel:";
if (cadenaOriginal.includes(valorEliminar)) {
  let cadenaSinValor = cadenaOriginal.replace(valorEliminar, '').trim();
  let numeros = cadenaSinValor;
  return numeros
} else {
  return ''
}
}

getMultiple(keys: string[]) {
  const promises = [];

  keys.forEach( key => promises.push(this.storage.get(key)) );

  return Promise.all(promises).then( values => {
    const result = {};

    values.map( (value, index) => {
      result[keys[index]] = value;
    });

    return result;
  });
}
public requestAutocompleteItems = (text: string): Observable<Response> => {
  return this.servicio.buscarClientesPorCompania(text, this.companiasId)
};

enviarWhatsApp(item) {
      let recibo = ''
      let data = []
      let numero =  item.numeroTelefono
      const numerovalorFactura = item.valorFactura.toLocaleString('en');
      const numerovalorPagado = item.valorPagado.toLocaleString('en');
      const numerovalorPendiente = item.valorPendiente.toLocaleString('en');
      recibo +=  '   Asi vamos...: ' + '\n'
      recibo +=  '   Fecha: ' + item.fecha + '\n'
      recibo +=  '   Nombre completo: ' + item.nombreCompleto + '\n'
      recibo +=  '   Factura: ' + item.numeroFactura + '\n'
      recibo +=  '   Valor factura: ' + numerovalorFactura + '\n'
      recibo +=  '   Pagado: ' + numerovalorPagado + '\n'
      recibo +=  '   Pendiente: ' + numerovalorPendiente + '\n'

        recibo +=  '  ---------------------------------' + '\n'
        data.push(recibo)

        const url = `https://api.whatsapp.com/send?phone=${numero}&text=${encodeURIComponent(
                  recibo
        )}`;
       window.open(url, '_system');
}

getBase64ImageFromURL(url) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL("image/png");

      resolve(dataURL);
    };

    img.onerror = error => {
      reject(error);
    };

    img.src = url;
  });
}

async generarPDF(item: any) {
  this.isLoading = true;
  let responseCompania = await this.dian.devolverCompania()
  this.companiasId = this.companiasId == undefined ? responseCompania : this.companiasId

  if(this.companiasId == undefined) {
    this.companiasId = 2
  }
  let recibo = ''
      let data = []
      const numerovalorFactura = item.valorFactura.toLocaleString('en');
      const numerovalorPagado = item.valorPagado.toLocaleString('en');
      const numerovalorPendiente = item.valorPendiente.toLocaleString('en');

      recibo +=  '   Fecha: ' + item.fecha + '\n'
      recibo +=  '   Nombre completo: ' + item.nombreCompleto + '\n'
      recibo +=  '   Factura: ' + item.numeroFactura + '\n'
      recibo +=  '   Valor factura: ' + numerovalorFactura + '\n'
      recibo +=  '   Pagado: ' + numerovalorPagado + '\n'
      recibo +=  '   Pendiente: ' + numerovalorPendiente + '\n'

        recibo +=  '  ---------------------------------- ' + '\n'
        data.push(recibo)

      const estilo = {
        encabezado: {
          fontSize: 22,
          bold: true,
          alignment: 'center',
          margin: [0, 0, 0, 10], // Margen inferior de 10 unidades
        },
        parrafo: {
          fontSize: 12,
          alignment: 'center',
          margin: [0, 0, 0, 5], // Margen inferior de 5 unidades
        },
        cita: {
          italics: true,
          alignment: 'center',
          margin: [0, 0, 0, 10], // Margen inferior de 10 unidades
        },
        lista: {
          fontSize: 20,
          bold: true,
          margin: [0, 0, 0, 5], // Margen inferior de 5 unidades
        },
      };

  const docDefinition = {
    content: [
      {
        image: await this.getBase64ImageFromURL(`assets/imgs/${this.companiasId}.jpeg`),
        width: 200, // Ancho de la imagen en unidades
        alignment: 'center',
      },
  { text: 'Este es tu resumen', style: 'encabezado' },
   { text: '\n' },
      {
        ul: data.map((dato) => {
          return dato.toString();
        }),
        style: 'lista',
      },
    ],
    styles: estilo
  };



  pdfMake.createPdf(docDefinition).download(`cuenta-por-cobrar.pdf`);
  this.isLoading = false;

}

limpiarCampos() {
  this.fechaPagoReal = new Date(),
  this.detalle = ''
  this.comprobantePago = ''
}
buscarClienteSelect() {
  this.buscarClientes()
 }
 async buscarClientes() {
  let responseCompania = await this.dian.devolverCompania()
    let companiaId = this.companiasId == undefined ? responseCompania : this.companiasId
    if(companiaId == undefined) {
      this.utils.mensajeMuestro('Debe salir y volver a entrar a la aplicación para generar la nota crédito..','Advertencia!','advertencia')
      return
    }
  this.servicio.buscarClientesPorCompaniaAll(companiaId)
  .subscribe(async (data: any)=>{
    this.isButtonDisabledCliente = true;
    let clientes: any = data;
    this.listaClientes = clientes;

    let modal = this.modalControllers.create(ClienteSelectPage, { data: this.listaClientes }
      )
    modal.present();

    modal.onDidDismiss(data => {
      if (data) {
        this.clienteId.push({value:data.value, display:data.display})
        let cliente: valueDisplay[] = [{
          value:data.value,
          display:data.display
        }]
        this.clienteId = cliente
        // const actionClienteCaja = new fromData.CargarValueDisplaySuccessActions(cliente);
        const actionClienteCaja = new fromClienteSelect.CargarValueDisplaySuccessActions(cliente);
        this.store.dispatch(actionClienteCaja);
        this.valoresCliente = 'Buscar Cliente : ' + data.display;
        this.isButtonDisabledCliente = false;
      } else {
        this.isButtonDisabledCliente = false;
      }
    })
  })
}

buscarParaPagarPorCuota(item:any,valorPendienteInd:any) {


  this.servicio.buscarPlanDePagosConIntereses(item.cuentasPorCobrarId).subscribe(async (data: any)=>{
    if(NUBE_AWS) {
      data = JSON.parse(data['_body']).data[0]
      let planDePagos = data
      console.log(planDePagos)



planDePagos.forEach(cuota => {

  cuota.numeroDeCuota = cuota.nroCuota
  cuota.montoDeLaCuota = cuota.valorCuota
  cuota.valorPagado = cuota.valorPagado
  cuota.fechaVencimiento = cuota.fechaVencimiento
  cuota.estado = cuota.estadonuevo
  cuota.totalPagado = cuota.valorCuota
});

    this.planDePagos = planDePagos
    }
  },(error)=> console.log(error))

}
cambiarCheckImprimir(){
  localStorage.setItem('ImprimirCuentasPorCobrar', this.CheckImprimir.toString());

}

}



// WEBPACK FOOTER //
// ./src/pages/cuentas-por-cobrar/cuentas-por-cobrar.ts